import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { BookingWindowClosedContainer } = await import('@containers/Payment/ErrorScreens/BookingWindowClosed');
    return {
        Component: BookingWindowClosedContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
